import { IonButton, IonCol, IonRow } from '@ionic/react';
import { Field, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import LabeledInput from '../../../mdc/LabeledInput';
import { uppercaseFirstLetter } from '../../../util/string';
import Form from '../../common/Form';
import styled from 'styled-components';

const StyledForm = styled(Form)`
  padding: 0 24px;
`;
const ButtonRow = styled(IonRow)`
  margin-top: 8px;
  width: 100%;
`;

interface NameFormProps {
  isAdmin: boolean;
  name: string;
  onSubmit: (values: { name: string }) => Promise<void>;
}

const NameForm: React.FC<NameFormProps> = ({ isAdmin, name, onSubmit }) => {
  const nameLabel = isAdmin ? 'Name' : 'Clinic name';
  return (
    <Formik
      initialValues={{ name }}
      onSubmit={onSubmit}
      validateOnMount
      validationSchema={Yup.object({
        name: Yup.string()
          .min(3, `${nameLabel} is too short`)
          .max(120, `${nameLabel} is too long`)
          .required(`${nameLabel} is required`),
      })}
    >
      {({ handleSubmit, isValid, errors, touched, isSubmitting }) => (
        <StyledForm onSubmit={handleSubmit}>
          <IonRow>
            <IonCol>
              <Field
                name="name"
                as={LabeledInput}
                label="Name"
                error={
                  touched.name && uppercaseFirstLetter(errors.name as string)
                }
              />
            </IonCol>
          </IonRow>
          <ButtonRow>
            <IonCol>
              <IonButton
                type="submit"
                disabled={!isValid || isSubmitting}
                expand="block"
              >
                Save
              </IonButton>
            </IonCol>
          </ButtonRow>
        </StyledForm>
      )}
    </Formik>
  );
};

export default NameForm;
